// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"a541fb7a","232":"197109b8","237":"eb9aec06","526":"adfcb564","787":"befb3b66"}[chunkId] + ".chunk.js";
};